import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./Analysis.module.scss";

interface AnalysisProps {
  text: string;
}

const Analysis: FC<AnalysisProps> = ({ text }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>Alphamind Analysis</h2>

      <div
        className={`${styles.analysisCard} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <div className={styles.quoteIcon}>“</div>
        <p className={styles.analysisText}>{text}</p>
      </div>
    </div>
  );
};

export default Analysis;
